module.exports = __webpack_public_path__ + "prod/20261104151832/img/experience.942f4ebf.png";